var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutubeSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.845 1.82283C18.3206 0.889992 17.7515 0.718409 16.5927 0.653159C15.4351 0.574617 12.5242 0.541992 10.0024 0.541992C7.47579 0.541992 4.56371 0.574617 3.40733 0.651951C2.25096 0.718409 1.68063 0.888784 1.15138 1.82283C0.61125 2.75445 0.333333 4.35912 0.333333 7.1842V7.19387C0.333333 10.0069 0.61125 11.6236 1.15138 12.5456C1.68063 13.4784 2.24975 13.6476 3.40613 13.7261C4.56371 13.7938 7.47579 13.8337 10.0024 13.8337C12.5242 13.8337 15.4351 13.7938 16.5939 13.7273C17.7527 13.6488 18.3218 13.4796 18.8462 12.5468C19.3912 11.6248 19.6667 10.0081 19.6667 7.19507V7.18541C19.6667 4.35912 19.3912 2.75445 18.845 1.82283Z",
    fill: "#F44336"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.58333 10.8125V3.5625L13.625 7.1875L7.58333 10.8125Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeSquare);
export default __webpack_public_path__ + "static/media/youtube_square.9a45d838e41154ccfb6a76cb2f2ed046.svg";
export { ForwardRef as ReactComponent };